export default {
  mounted(el) {
    const originalText = el.innerText;
    el.dataset.originalText = originalText;
    el.innerText = "";

    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@#$%^&*()_+ｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝ";

    const resolveText = () => {
      let iterations = 0;
      const maxIterations = 15;

      const interval = setInterval(() => {
        el.innerText = originalText
          .split("")
          .map((char, index) => {
            if (index < iterations) {
              return originalText[index];
            }
            return characters[Math.floor(Math.random() * characters.length)];
          })
          .join("");

        if (iterations >= originalText.length) {
          clearInterval(interval);
          el.innerText = originalText;
        }

        iterations += 1 / 3;
      }, 30);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          resolveText();
          observer.disconnect();
        }
      },
      { threshold: 0.1 },
    );

    observer.observe(el);
  },
};
